import React from 'react';
import { VERSION }  from './Version.js'
import SSO from './SSO'
import '@fortawesome/fontawesome-free/css/fontawesome.css'
import '@fortawesome/fontawesome-free/css/solid.css'


const formatter = new Intl.NumberFormat('pt-BR');


export class TopBar extends React.Component {


	constructor(props) {
		super(props)
		this.mouseDown = false
	}


	onMouseDown(event) {
		this.mouseDown = true
		let div = document.querySelector('.RulerItem')
		this.lrX = div.offsetLeft - event.clientX
		event.preventDefault()
	}


	onMouseUp() {
		this.mouseDown = false
	}


	onMouseMove(event) {
		if (this.mouseDown) {
			let div = document.querySelector('.RulerItem')
			let pos = event.clientX + this.lrX 
			if (pos < 1)
				pos = 1
			if (pos > 120)
				pos = 120
			if (pos % 3 !== 0)
				pos += (3 - (pos % 3))
			div.style.left = pos + "px"
			let rate = pos / 6;
			this.props.app.setLearningRate(rate)
		}
	}


	setLearningRate(rate) {
		if (rate > 0.0001 && rate <= 20.0001) {
			this.props.app.setLearningRate(rate)
			let div = document.querySelector('.RulerItem')
			if (div != null) {
				div.style.left = rate * 20 + "px"
			}
		}
	}


	setTrainingSpeed(up) {
		let speed = this.props.trainingSpeed + (up ? 1 : -1)
		if (speed >= 1 && speed <= 5) {
			this.props.app.setTrainingSpeed(speed)
		}
	}	


	switchUseSharedData() {
		let useRandom = this.props.useRandomData
		if (this.props.useSharedData && !this.props.useRandomData) {
			useRandom = true
		}
		this.props.app.setTrainingData(!this.props.useSharedData, useRandom)
	}



	switchUseRandomData() {
		let useShared = this.props.useSharedData
		if (this.props.useRandomData && !this.props.useSharedData) {
			useShared = true
		}
		this.props.app.setTrainingData(useShared, !this.props.useRandomData)
	}


	getTrainingSpeed(speed) {
		switch (speed) {
			case 1: return "10"
			case 2: return "50"
			case 3: return "100"
			case 4: return "500"
			default: return "1000";
		}
	}


	renderRulerTicks() {
		let jsx = []
		for (let i = 0; i <= 40; i++) {
			jsx.push(
				<div 
					key = {"TICK" + i}
					className = "RulerTick"
					style = {{
						left: i * 3 + 4,
						marginTop : (i % 4 === 0 ? (i % 20 === 0 ? -10 : -6) : -3),
						height: (i % 4 === 0 ? (i % 20 === 0 ? 10 : 6) : 3)
					}}/>
			)
		}
		return jsx
	}


	renderSignal(num) {
		return (
			<div 
				className = "SignalValue" 
				style = {{
					height: 8 + 3 * num, 
					top: 26 - 3 * num,
					backgroundColor: this.props.trainingSpeed >= num ? "#666666" : "#d6d6d6"}}>
			</div>
		)
	}


	renderLogo() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Version {VERSION} 
				</div>
				<div className = "ButtonMain">
					<div className = "TopBarNameBold">neural.</div>
					<div className = "TopBarNameThin" style = {{marginLeft: "-5px"}}>net</div>
				</div>
			</div>
		)
	}


	renderTrainingSteps() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Training Steps 
				</div>
				<div className = "ButtonMain">
					<div className = "Training" style = {{width: '90px'}}>
						{formatter.format(this.props.trainingCount)}
					</div>
				</div>
			</div>
		)
	}


	renderTestSteps() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Test Steps 
				</div>
				<div className = "ButtonMain">
					<div className = "Training" style = {{width: '90px'}}>
						{formatter.format(this.props.testCount)}
					</div>
				</div>
			</div>
		)
	}


	renderSensitivity() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Sensitivity 
				</div>
				<div className = "ButtonMain">
					<div className = "Training" style = {{width: '76px'}}>
						{this.props.sensitivity.toFixed(4)}
					</div>
				</div>
			</div>
		)
	}


	renderSpecificity() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Specificity 
				</div>
				<div className = "ButtonMain">
					<div className = "Training" style = {{width: '76px'}}>
						{this.props.specificity.toFixed(4)}
					</div>
				</div>
			</div>
		)
	}


	renderMeanError() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Loss (MAE) 
				</div>
				<div className = "ButtonMain">
					<div className = "Training" style = {{width: '76px'}}>
						{this.props.meanError.toFixed(4)}
					</div>
				</div>
			</div>
		)
	}


	renderCurrentError() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Current Error 
				</div>
				<div className = "ButtonMain">
					<div className = "Training" style = {{width: '86px'}}>
						{this.props.currentError.toFixed(4)}
					</div>
				</div>
			</div>
		)
	}


	renderLearningRate() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Learning Rate 
				</div>
				<div className = "ButtonMain">
					<div className = "ButtonMinus" onClick = {() => this.setLearningRate(this.props.learningRate - 0.5)}>
						<img src = {"l-arr.png"} height = '14px' alt = '-'></img>
					</div>
					<div 
						className = "Learning" 
						onMouseLeave = {() => this.onMouseUp()}
						onMouseMove = {(event) => this.onMouseMove(event)}>
						<div className = "Ruler">
							{this.renderRulerTicks()}
						</div>
						<div 
							className = "RulerItem"
							style = {{left: this.props.learningRate * 6}}
							onMouseDown = {(event) => this.onMouseDown(event)}
							onMouseUp = {() => this.onMouseUp()}> 
							{this.props.learningRate.toFixed(1)}
							<div className = "RulerItemIndicator">
								&#9662;
							</div>
						</div>
					</div>
					<div className = "ButtonPlus" onClick = {() => this.setLearningRate(this.props.learningRate + 0.5)}>
						<img src = {"r-arr.png"} height = '14px' alt = '-'></img>
					</div>
				</div>
			</div>
		)
	}


	renderTrainingSpeed() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Speed 
				</div>
				<div className = "ButtonMain">
					<div className = "ButtonMinus" onClick = {() => this.setTrainingSpeed(false)}>
						<img src = {"l-arr.png"} height = '14px' alt = '-'></img>
					</div>
					<div className = "SpeedSpace"></div>
					{this.renderSignal(1)}
					{this.renderSignal(2)}
					{this.renderSignal(3)}
					{this.renderSignal(4)}
					{this.renderSignal(5)}
					<div className = "SignalBottom"></div>
					<div className = "SpeedValue" style = {{width: "64px", paddingLeft: "0px"}}>
						{this.getTrainingSpeed(this.props.trainingSpeed)} 
					</div>
					<div className = "SpeedLabel">
						steps/s
					</div>
					<div className = "SpeedSpace"></div><div className = "SpeedSpace"></div>
					<div className = "ButtonPlus" onClick = {() => this.setTrainingSpeed(true)}>
						<img src = {"r-arr.png"} height = '14px' alt = '-'></img>
					</div>
				</div>
			</div>
		)
	}


	renderTrainingData() {
		return (
			<div className = "Button">
				<div className = "ButtonTop">
					Training- & Test Data 
				</div>
				<div className = "ButtonMain">
					<div className = "UseData">
						<div className = "UseDataText">
							Stored
						</div>
						<div 
							className = "UseDataCheck" 
							onClick = {() => this.switchUseSharedData()}>
							{this.props.useSharedData ? <img src = 'check.png' width = '15px' alt = 's1'></img> : null}
						</div>
						<div className = "UseDataSpace"></div>
						<div className = "UseDataText">
							Random
						</div>
						<div 
							className = "UseDataCheck" 
							onClick = {() => this.switchUseRandomData()}>
							{this.props.useRandomData ? <img src = 'check.png' width = '15px' alt = 's3'></img> : null}
						</div>
					</div>
				</div>
			</div>			
		)
	}


	renderUserLogout() {
		return (
			<div className = "Button" style = {{float: "right"}}>
				<div className = "ButtonTop">
				</div>		
				<div className = "ButtonMain" style = {{padding: "0px"}}>
					<div className = "TopBarName">{this.props.user.firstname + " " + this.props.user.lastname}</div>
					<div className = "TopBarMatrNr">{this.props.user.matrnr.toUpperCase()}</div>
					<div className = "TopBarLogout" onClick = {() => SSO.doLogout()}>
						<i className = 'fas fa-power-off' style = {{fontSize: "12pt"}}></i>
					</div>		
				</div>
			</div>
		)
	}


	render() {
		return (
			<div className = "ButtonBar">
				<div className = "ButtonBarTop"/>
				{this.renderLogo()}
				{this.renderTrainingSteps()}
				{this.renderMeanError()}
				{this.renderTestSteps()}
				{this.renderSensitivity()}
				{this.renderSpecificity()}
				{this.renderLearningRate()}
				{this.renderTrainingSpeed()}
				{this.renderTrainingData()}
				{this.renderUserLogout()}
			</div>
		)
	}

	
}